module.exports = __webpack_public_path__ + "img/main.136f6255.jpg";